module.exports = __webpack_public_path__ + "static/media/user1.8a45bf29.png";